<template>
  <div class="service-content-projects" v-if="service">
    <div class="content">
      <ContentText v-if="service.textModule" :data="service.textModule" />
      <FeaturedProjects :projects="service.featuredProjects" />
    </div>
    <CtaContactPerson
      v-if="service.ctaModule"
      :data="service.ctaModule"
      :service-name="service.title ?? ''"
    />
  </div>
</template>

<script setup lang="ts">
import CtaContactPerson from '~/components/cta/CtaContactPerson.vue';
import FeaturedProjects from '~/components/service-modules/FeaturedProjects.vue';
import type { ServiceFragment } from '#gql';
import ContentText from '~/components/content-modules/ContentText.vue';

const props = defineProps<{
  service: ServiceFragment;
}>();
</script>

<style scoped lang="scss">
.service-content-projects {
  > .content {
    --background: var(--color-black);

    background-color: var(--color-black);
    color: var(--color-white);
    padding-top: 4.5rem;
    padding-bottom: 2.5rem;
  }
}
</style>
